import { useEffect, useState } from "react";
import { Space, Table, Tag } from "antd";
import dayjs from "dayjs";
import { PageHeader } from "../../components/PageHeader";
import { TableDownload } from "../../components/TableDownload";
import { ColumnPicker, useColumnPicker } from "../../components/ColumnPicker";
import { api } from "../../helpers/api";
import { fmtMVR } from "../../helpers/format";
import { DT_FORMATS } from "../../helpers/constants";
import type { ExportColumns } from "../../helpers/csv";
import type { ProcurementStatusRow } from "../../api-models";

// One definition behind both the table and its export.
const COLUMNS: ExportColumns<ProcurementStatusRow> = [
  { title: "Doc No", dataIndex: "docNo" },
  { title: "Type", dataIndex: "type", render: (v) => <Tag>{v}</Tag> },
  { title: "Status", dataIndex: "status" },
  { title: "Supplier", dataIndex: "supplierName" },
  { title: "Total", dataIndex: "totalLaari", render: (v) => (v != null ? fmtMVR(v) : "-") },
  { title: "Created", dataIndex: "createdAt", render: (v) => dayjs(v).format(DT_FORMATS.date) },
];

export default function ProcurementStatusPage() {
  const [rows, setRows] = useState<ProcurementStatusRow[]>([]);
  const cols = useColumnPicker("report:procurement-status", COLUMNS);

  useEffect(() => {
    api.get<ProcurementStatusRow[]>("/reports/procurement-status").then((res) => setRows(res.data));
  }, []);

  return (
    <div>
      <PageHeader
        title="Procurement Status"
        extra={
          <Space>
            <ColumnPicker state={cols} />
            <TableDownload name="Procurement Status" columns={cols.visible} dataSource={rows} disabled={!rows.length} />
          </Space>
        }
      />
      <Table rowKey={(r) => `${r.type}-${r.docNo}`} dataSource={rows} columns={cols.visible} />
    </div>
  );
}
